import {
  Command,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from '@/components/ui/atoms/command'
import { cn } from '@/lib/client'
import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'

const searchAtom = atom<string>('')

interface SearchProps {
  theme?: string | undefined
  placeholder: string
  suggestions: Array<{
    heading: string
    items: Array<{
      type: string
      label: string
      value: string
    }>
  }>
  handleSearch: (value: { type?: string; value: string }) => void
}

export default function Search({
  theme = 'dark',
  placeholder,
  suggestions,
  handleSearch,
}: SearchProps) {
  const $search = useStore(searchAtom)

  return (
    <Command
      className={cn(
        'rounded-xl border shadow-md focus-within:ring-2 focus-within:ring-orange-400',
        theme,
      )}
    >
      <CommandInput
        aria-label="Pesquisar"
        placeholder={placeholder}
        onKeyDown={({ key }) => {
          if (key === 'Escape') searchAtom.set('')
        }}
        value={$search}
        onValueChange={(ev) => searchAtom.set(ev)}
      />
      <CommandList className={cn($search?.trim().length === 0 && 'hidden')}>
        {[
          {
            heading: 'Pesquisar por',
            items: [{ type: 'free', label: $search, value: $search }],
          },
          ...suggestions,
        ]?.map((s, key_a) => {
          return (
            <div key={s.heading}>
              <CommandGroup heading={s.heading}>
                {s.items.map((item) => {
                  return (
                    <CommandItem
                      onSelect={(value) => {
                        handleSearch({
                          type: item.type,
                          value,
                        })
                        searchAtom.set('')
                      }}
                      className="cursor-pointer"
                      key={`${key_a}_${item.label}`}
                      value={item.label}
                    >
                      <span>{item.label}</span>
                    </CommandItem>
                  )
                })}
              </CommandGroup>
              {suggestions.length > 1 && key_a < s.items.length - 1 && (
                <CommandSeparator />
              )}
            </div>
          )
        })}
      </CommandList>
    </Command>
  )
}
